// @ts-nocheck
import { createBrowserHistory, History } from '/home/ZCIPClient/workpath/164805/code/code/promotion-frontend/promotionh5DXP/node_modules/@umijs/runtime';

let options = {
  "basename": "/gcp/luckyDraw/"
};
if ((<any>window).routerBase) {
  options.basename = (<any>window).routerBase;
}

// remove initial history because of ssr
let history: History = process.env.__IS_SERVER ? null : createBrowserHistory(options);
export const createHistory = (hotReload = false) => {
  if (!hotReload) {
    history = createBrowserHistory(options);
  }

  return history;
};

export { history };
